<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">车辆年检</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="inspection-bg">
    </div>
    <div class="inspection-mesg" style="top: -136px;">
      <div class="inspection-choosecar" @click="showPopup()">
        <img class="inspection-mesgicon" src="/static/chepai.png" />
        <div class="inspection-choosebox">
          <!-- <div :class="licenseItem.car_no?'inspection-carnum1':'inspection-carnum'">{{licenseItem.car_no? licenseItem.car_no : '请选择车辆'}}</div> -->
          <div :class="settlementItem.couponname ?'inspection-carnum1':'inspection-carnum'">{{settlementItem.couponname ? settlementItem.couponname : '请选择卡券'  }}</div>
          <img class="inspection-checkmore" src="/static/newicon/more.png" />
        </div>
      </div>
      <div class="inspection-mesginput">
        <img class="inspection-mesgicon" src="/static/name.png" />
        <input class="inspection-name" placeholder="请输入联系人姓名" v-model="name" />
      </div>
      <div class="inspection-mesginput">
        <img class="inspection-mesgicon" src="/static/dianhuaicon.png" />
        <input class="inspection-name" placeholder="请输入联系人电话" v-model="phone" />
      </div>
      <div class="inspection-mesginput" @click="showDatepop()">
        <img class="inspection-mesgicon" src="/static/timeicon.png" />
        <div :class="date?'inspection-time1' : 'inspection-time'">{{date? date : '请选择预约日期'}}</div>
      </div>
      <!-- <div class="inspection-mesginput" @click="showTimepop()">
        <img class="inspection-mesgicon" src="/static/timeicon.png" />
        <div :class="time? 'inspection-time1' : 'inspection-time'">{{time? time : '请选择预约时间'}}</div>
      </div> -->
    </div>
    <div class="inspection-price" style="margin-top: -110px;">
      <div class="inspection-pricetitle1">
        <img class="inspection-priceicon" src="/static/newprojecticon/title.png" />
        <div class="inspection-pricetitlename">保养服务须知</div>
      </div>
      <div style="margin-bottom: 10px;">
        <div>
          <div class="inspection-pricetitlename">1.预约成功的用户客服会打电话与您联系，请注意收听；</div>
          <div class="inspection-pricetitlename">2.保养有关问题请与门店协商；</div>
          <div class="inspection-pricetitlename">3.有问题请联系客服：400-893-2218</div>
        </div>
      </div>
    </div>
    <!-- 结算方式 开始 -->
    <!-- <div class="reserceDesc_yuyuemesg">
        <div class="reserceDesc_fuwutitle">
          <img class="reserceDesc_fuwuimg" src="/static/newicon/title2.png" />
          <div class="reserceDesc_fuwutitlename">结算方式</div>
        </div>
        <div class="reserceDesc_fuwuDetail">
          <div class="reserceDesc_fuwuprice">
            <div class="reserceDesc_fuwupricename">可用余额</div>
            <div class="reserceDesc_jiesuancheck">
              <div class="reserceDesc_jiesuanpricenum">￥{{amount}}</div>
              <input type="radio" name="pay_type" />
            </div>
          </div>
          <div class="reserceDesc_fuwuprice" @click="showPopup()">
            <div class="reserceDesc_fuwupricename">服务券</div>
            <div class="reserceDesc_jiesuancheck">
              <div class="reserceDesc_jiesuanpricenum"></div>
              <div class="reserceDesc_jiesuanpricenum">已选</div>
              <div class="reserceDesc_jiesuanpricenum">未选</div>
              <input type="radio" name="pay_type" />
            </div>
          </div>
        </div>
      </div> -->

    <div class="inspection-yuyue" @click="buttonClicked ? '' : confirmtijiao()">确认提交</div>
    <div></div>
    <!-- 支付 开始 -->
    <!-- <div class="page_button reserceDesc_button" @click="package_id=='' ? (!!settlementItem.selectedID ? reserve(): yuyuepay()): reserve()">
      <div class="page_zhifu">{{ package_id=='' ? "确定支付并预约保养" : "预约保养" }}</div>
    </div> -->
    <!-- 支付 结束 -->
    <!-- 日期弹出层 开始 -->
    <van-popup v-model="showDate" position="bottom" :style="{ height: '40%' }" round>
      <van-datetime-picker v-model="currentDate" :formatter="formatter" @confirm="checkDate" @cancel="onDateCancel"
        type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate" />
    </van-popup>
    <!-- 日期弹出层 结束 -->
    <!-- 时间弹出层 开始 -->
    <van-popup v-model="showTime" position="bottom" :style="{ height: '40%' }" round>
      <!-- <van-picker title="选择时间" show-toolbar :columns="times" @confirm="checkTime" @cancel="onTimeCancel" /> -->
      <van-datetime-picker v-model="currentTime" @confirm="checkTime" @cancel="onTimeCancel" type="time" :max-hour="maxHour" />
    </van-popup>
    <!-- 时间弹出层 结束 -->
    <!-- section-method:可使用券 start -->

    <!-- 卡券弹出层 开始 -->
    <van-popup v-model="showCardList" position="bottom"  closeable :style="{ height: '50%' }">
      <div class="cardlist_popup_top">
        <div class="cardlist_popup_topcenter">选择卡券</div>
      </div>
      <div class="cardlist_popup_list">
        <div :class="item.checked ? 'cardlist_popup_box1' : 'cardlist_popup_box2'" v-for="(item,index) in settlementItem.couponList" @click="couponChange(index)">
          <div>
            <div class="cardlist_popup_boxtop">卡券名称：{{ item.name ? item.name : item.product.name }}</div>
            <div class="cardlist_popup_boxbot">到期日期：{{ item.overdue_at }}</div>
          </div>
          <img class="cardlist-pop-check" :src="item.checked ? '../../../static/checkdeicon.png' : '../../../static/weixuancard.png'" />
        </div>
      </div>
    </van-popup>
    <!-- 卡券弹出层 结束 -->
    <!-- <van-popup v-model="showkaquan" position="bottom" :style="{ 'max-height': '70%' }">
      <div class="popup_top" @click="guanbi()">
        <img class="guanbi" src="/static/guanbi.png" />
        <div>可使用券</div>
      </div>
      <div class="couponCont maskCont">
        <div class="reserceDesc_section">
          <div class="scroll-div">
            <div class="couponCell" hover-class="weui-cell_active">
              <div class="cellLeft" @click="couponChange(index)">
                <div>{{ item.product.id == serviceItem.product_id ? '可用':'不可用' }}</div>
                <div class="cont">{{ item.product ? item.product.name : '' }}</div>
                <div>编号: {{ item.card_no }}</div>
                <div>到期: {{ item.overdue_at }}</div>
              </div>
              <input type="radio" @click="couponChange(index)" id="couponChange" name="coupon" :data-index="index"
                :disabled="item.product.id != serviceItem.product_id" :checked=" item.checked " />
            </div>
          </div>
        </div>
      </div>
    </van-popup> -->
    <!-- section-method:可使用券 end -->
    <!-- 选择地址 开始 -->
    <!--  <div v-if="showaddress" class="map">
      <iframe id="mapPage" :src="reportUrl" frameborder="0" :style="{width: width, height:height}">
      </iframe>
    </div> -->
    <!-- 选择地址 结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog, Toast
  } from 'vant';
  const openLoading = () => {
    Toast.loading({
      message: "加载中",
      duration: 0, // toast不消失
    });
  }
  export default {
    data() {
      return {
        name: "", //联系人
        phone: "", //联系人电话
        product_id: "",//商品id
        store_id: "",
        showDate: false, //是否显示日期弹框
        showTime: false, //是否显示时间弹框
        minDate: new Date(),
        maxDate: new Date(2025, 12, 31),
        currentDate: new Date(),
        maxHour: "23",
        currentTime: "12:00",
        time: "",
        date: "",
        times: [],
        serviceDetail: "",
        settlementItem: {
          canAmountPay: false, // 前端计算可用余额是否大于服务价格,默认为false
          couponList: [], // 服务券列表,默认为空
          isAmountPay: false, // 用户是否使用余额结算,默认为false
          selectedID: "", // 用户选择服务券的编号,默认为空
          couponname:'',//已选服务券名称
        }, // 接口获取结算方式
        showCardList: false,
        buttonClicked: false,
      }
    },
    created() {
      //最小日期
      var resDate = "2021/01/01";
      this.minDate = new Date(resDate)
      let that = this
      if (localStorage.getItem('userinfo')) {
        this.phone = JSON.parse(localStorage.getItem('userinfo')).mobile;
      } else {
        Dialog.confirm({
            title: '提示',
            message: '请先绑定手机',
          })
          .then(() => {
            that.$router.push({
              path: "/changePhoneNum"
            })
          })
          .catch(() => {
            return false;
          });
      }

      if (this.$route.query.store_id) {
        this.store_id = this.$route.query.store_id
      } else {
        this.store_id = ""
      }

      if (this.$route.query.product_id) {
        this.product_id = this.$route.query.product_id
      } else {
        this.product_id = ""
      }
      // this.request('getUserInfo')
      this.request("getStoreservice", {
        product_id: this.product_id,
        store_id: this.store_id
      })
      this.getChoosetime()
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      showDatepop() {
        this.showDate = true
      },
      showTimepop() {
        this.showTime = true
      },
      //关闭弹出层
      guanbi() {
        this.showCardList = false
      },
      showPopup() {

        if (this.settlementItem.couponList.length == 0) {
          this.$toast({
            message: '暂无可用卡券',
          })
        } else {
          this.showCardList = true
        }

      },
      // 选择服务券
      couponChange(sel_index) {
        let that = this
        let settlementItem = that.settlementItem;
        let couponList = settlementItem.couponList;
        couponList.map(function(item, i) {
          if (i == Number(sel_index)) {
            if (item.checked == false) {
              item.checked = true
              that.settlementItem.selectedID = item.id;
              that.settlementItem.couponname = item.product.name
              // //满减券优惠金额
              // that.preferentialAmount = item.amount
              // //卡券金额
              // let originalPrice = parseFloat(that.preferentialAmount)
              // //商品价格
              // let price = parseFloat(that.serviceList.price)
              // //实付金额
              // that.payAmount = price > originalPrice ? (price - originalPrice).toFixed(2) : 0
            } else {
              item.checked = false;
              that.settlementItem.selectedID = ''
              // //满减券优惠金额
              // that.preferentialAmount = 0
              // //实付金额
              // that.payAmount = parseFloat(that.serviceList.price)
            }
          } else {
            item.checked = false;
          }
        })
        that.settlementItem = settlementItem;
        console.log("settlementItem", settlementItem)
        //that.settlementItem.isAmountPay = false;
        //that.isWeixinPay = false
        that.guanbi();
      },
      //选择日期
      checkDate(value) {
        let times1 = [{
          starttime: 8,
          endtime: 9,
          time: "8:00-9:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 9,
          endtime: 10,
          time: "9:00-10:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 10,
          endtime: 11,
          time: "10:00-11:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 11,
          endtime: 12,
          time: "11:00-12:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 14,
          endtime: 15,
          time: "14:00-15:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 15,
          endtime: 16,
          time: "15:00-16:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 16,
          endtime: 17,
          time: "16:00-17:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 17,
          endtime: 18,
          time: "17:00-18:00",
          ischeck: false,
          isOptional: false
        }]
        let d = new Date(value)
        let resDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        this.date = resDate
        this.showDate = false
        let datestart = new Date().getTime()
        var datedate = new Date(datestart).getDate();
        if (d.getDate() == datedate) {
          this.getChoosetime()
        } else {
          let times = []
          times1.map(function(item, i) {
            times.push(
              item.time
            )
          })
          this.times = times
        }
        //let times1 = this.times
      },
      //取消弹框日期
      onDateCancel() {
        this.showDate = false
      },
      //选择时间
      checkTime(value) {

        this.time = value
        this.showTime = false
      },
      //获取时间段
      getChoosetime() {
        let datestart = new Date().getTime()
        var hourse = new Date(datestart).getHours()
        var datedate = new Date(datestart).getDate();
        let times1 = [{
          starttime: 8,
          endtime: 9,
          time: "8:00-9:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 9,
          endtime: 10,
          time: "9:00-10:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 10,
          endtime: 11,
          time: "10:00-11:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 11,
          endtime: 12,
          time: "11:00-12:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 14,
          endtime: 15,
          time: "14:00-15:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 15,
          endtime: 16,
          time: "15:00-16:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 16,
          endtime: 17,
          time: "16:00-17:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 17,
          endtime: 18,
          time: "17:00-18:00",
          ischeck: false,
          isOptional: false
        }]
        let times = []
        times1.map(function(item, i) {
          // if (item.starttime < hourse) {
          //   item.isOptional = false
          // } else {
          item.isOptional = true;
          if (item.isOptional) {
            times.push(
              item.time
            )
          }
          //}
        })
        this.times = times
        if (this.times.length == 0) {
          this.times = [{
            time: "今日已约满",
          }]
        }
        //this.times = times1
      },
      //取消时间弹框
      onTimeCancel() {
        this.showTime = false
      },
      formatter(type, val) {
        if (type === 'year') {
          return `${val}年`;
        } else if (type === 'month') {
          return `${val}月`;
        } else if (type === 'day') {
          return `${val}日`;
        }
        return val;
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true;
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === "number") {
            setTimeout(() => {
              this.buttonClicked = false;
            }, duration);
          }
          resolve(true);
        });
      },
      confirmtijiao() {
        this.buttonClickedFun.call(this, 3000);
        // console.log("点击")
        let that = this
        let mobile = JSON.parse(localStorage.getItem('userinfo')).mobile
        if (!mobile) {
          Dialog.confirm({
              title: '提示',
              message: '请先绑定手机',
            })
            .then(() => {
              that.$router.push({
                path: "/changePhoneNum"
              })
            })
            .catch(() => {
              return false;
            });
        }

        if (!this.date) {
          this.$toast({
            message: '请选择预约日期'
          })
          return
        }
        // if (this.showTopTipsFun.call(this, !this.bookingItem.date, 4)) return;

        let requestData = {
          product_id:this.product_id,
          store_id: this.store_id,
          username: this.name,
          book_at: this.date,
          mobile: this.phone,
          user_package_id: this.settlementItem.selectedID
        };
        openLoading()
        this.request("packageBook", requestData);
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
            //获取套餐详情
          case "getPackageDetail":
            httper.get("/store/service-detail", requestData, res => {
              // that.serviceItem = res.data product/detail
              // res.data.productItem.map(
              //   (item, index) => (item.checked = index === that.packageIndex)
              // );
              that.serviceItem = res.data;
            }, false);
            break;
            // 获取店铺服务详情
          case "getStoreservice":
            httper.post("store/ser-detail", requestData, res => {
              if (res.code == 0) {
                that.serviceList = res.data;
                this.request("getUserInfo")
                this.request("getCouponList");
              } else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true);
            break;
            //卡券列表
          case "getCouponList":
            httper.post("coupon/package-list", requestData, res => {
              let list = [];
              if (res.data) {
                console.log("res.data", res.data)
                res.data.map(function(item, i) {
                  if (item.product_id == that.serviceList.product_id && item.status == 0) {
                    list.push(item)
                  }
                })
                list.map(v => {
                  that.$set(v, 'checked', false)
                  return v
                })
                // if (list.length > 0) {
                //   list.map(v => {
                //     that.$set(v, 'checked', false)
                //     return v
                //   })
                //   list[0].checked = true
                //   that.settlementItem.selectedID = list[0].id
                //   that.preferentialAmount = list[0].amount
                //   //卡券金额
                //   let originalPrice = parseFloat(that.preferentialAmount)
                //   //商品价格
                //   let price = parseFloat(that.serviceList.price)
                //   //实付金额
                //   that.payAmount = price > originalPrice ? (price - originalPrice).toFixed(2) : 0
                //   // that.couponId = list[0].id
                // } else {
                //   // that.preferentialAmount = "无"
                //   that.payAmount = parseFloat(that.serviceList.price)
                // }
                that.settlementItem.couponList = list;
                console.log("couponList", that.settlementItem.couponList)

              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true);
            break;
            //获取个人信息余额
          case 'getUserInfo':
            httper.get('/wechat/user/info', requestData, res => {
              if (res.code == 0) {
                var amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //获取服务详情
          case 'getServiceDetail':
            httper.get('/store/service-detail', requestData, res => {
              that.serviceDetail = res.data
            }, false)
            break
            //预约
          case "packageBook":
            httper.post("/store/book", requestData, res => {
                if (res.code == 0) {
                  setTimeout(() => {
                    Toast.clear();
                  }, 1000)
                  // this.$toast({
                  //   message: "预约成功"
                  // });
                  Dialog.alert({
                    message: '预约成功',
                  }).then(() => {
                    that.$router.go(-1)
                  });
                  // this.$router.push({
                  //   path: "/orderList"
                  // })
                  // this.$swal({
                  //   title: "预约成功"
                  // }).then(confirm => {
                  //   if (confirm) {
                  //     this.$router.push({
                  //       path: "/detailBook",
                  //       query: {
                  //         id: res.data.related_id
                  //       }
                  //     });
                  //   } else {
                  //     return false;
                  //   }
                  // });
                } else {
                  this.$toast({
                    message: res.message
                  });
                }
              },true);
            break;
        }
      },

    },

  }
</script>

<style scoped>
  .inspection-bg {
    width: 100%;
    height: 195px;
    background: #FD8C00;

    /* background: linear-gradient(0deg, #EA6E56 0%, #E2523E 100%);
padding: 20px;
box-sizing: border-box; */

  }

  /*  .reservationnone{
    width: 100%;
    height: 136px;
  } */
  .van-picker__toolbar {
    align-items: center;
  }

  .inspection-upimgbox {
    width: calc(100% - 40px);
    margin: 0 20px 20px 20px;
    background-color: #fff;
    border-radius: 8px;
    /* height: 130px; */
    height: 252px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0 4px 5px 2px rgba(187, 187, 187, 0.3);
    /* position: absolute;
    top: 158px; */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .inspection-upimgbox1 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fileinput {
    opacity: 0;
    position: absolute;
    /* top: 0;
    left: 0;
    width: 100%;
    height: 100%; */
    cursor: pointer;
    width: 90%;
    height: 252px;
    border-radius: 24px;
  }

  .inspection-none {
    width: 100%;
    /* height: 110px; */
    /* height: 232px; */
    height: 175px;
  }

  .inspection-upimg {
    width: 100%;
    height: 100%;
  }

  .inspection-upimg1 {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto; */
  }

  .inspection-mesg {
    width: calc(100% - 40px);
    margin: 0 20px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 5px 2px rgba(187, 187, 187, 0.3);
    /* position: absolute;
    top: 158px; */
    position: relative;
    /* top: -50px; */
    top: -30px;
  }

  .inspection-mesginput {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    height: 30px;
  }

  .inspection-mesginput1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: 30px;
    width: 100%;
  }

  .inspection-addressbox {
    display: flex;
    align-items: center;
    width: 88%;
  }

  .inspection-mesgicon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  input {
    border: none;
  }

  ::-webkit-input-placeholder {
    font-size: 16px;
    color: #BBBBBB;
    text-align: left;
    background-color: transparent;
  }

  .inspection-choosecar {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    height: 30px;
  }

  .inspection-mesgicon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .inspection-choosebox {
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .inspection-carnum {
    font-size: 16px;
    color: #BBBBBB;
  }

  .inspection-carnum1 {
    font-size: 16px;
  }

  .inspection-checkmore {
    width: 15px;
    height: 15px;
  }

  .inspection-name {
    font-size: 16px;
    height: 30px;
    width: 280px;
  }

  .inspection-name ::-webkit-input-placeholder {
    font-size: 16px;
    color: #BBBBBB;
    text-align: start;
  }

  .inspection-price {
    width: calc(100% - 40px);
    margin: -20px 20px 20px 20px;
    padding: 20px;
    box-sizing: border-box;
    /* display: flex;
    justify-content: space-between;
    align-items: center; */
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .inspection-price1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .inspection-pricetitle {
    display: flex;
    align-items: center;
  }

  .inspection-pricetitle1 {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .inspection-priceicon {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .inspection-pricetitlename {
    font-size: 12px;
  }

  /* .service-price {
    color: #E35340;
    font-size: 12px;
  } */

  .reserceDesc-material {
    width: calc(100% - 40px);
    margin: 0 20px 80px 20px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .material-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .material-titleicon {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .material-titlename {
    font-size: 12px;
  }

  .material-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .material-mesg {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* margin-right: 20px; */
  }

  .material-mesgicon {
    width: 50px;
    height: 50px;
    background: rgba(255, 247, 215, 1);
    border-radius: 25px;
    margin-bottom: 10px;
  }

  .material-mesgtext {
    font-size: 12px;
  }

  .material-mesgtexttip {
    font-size: 10px;
    color: #666666;
  }

  .inspection-yuyue {
    width: calc(100% - 40px);
    margin: 20px 20px 0 20px;
    height: 46px;
    /*  background: linear-gradient(90deg, rgba(233, 109, 86, 1) 0%, rgba(226, 81, 62, 1) 100%);
    box-shadow: 0px 4px 5px 2px rgba(234, 110, 86, 0.3);
    */
    background: #FD8C00;
    box-shadow: 0 4px 5px 2px rgba(253, 140, 0, 0.3);
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    font-size: 14px;
    position: fixed;
    bottom: 20px;
  }

  .reserceDesc_yuyuemesg {
    width: calc(100% - 40px);
    margin: 20px;
    height: 150px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
  }

  .reserceDesc_fuwutitle {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .reserceDesc_fuwuimg {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .reserceDesc_fuwutitlename {
    font-size: 12px;
    /* font-weight: bold; */
    color: rgba(54, 54, 54, 1);
  }

  .reserceDesc_fuwuDetail {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .reserceDesc_fuwuname {
    margin-bottom: 15px;
  }

  .reserceDesc_fuwudesc {
    margin-bottom: 15px;
  }

  .reserceDesc_fuwuprice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }


  .reserceDesc_fuwupricename {}

  .reserceDesc_fuwupricenum {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
  }

  .reserceDesc_jiesuancheck {
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .reserceDesc_jiesuanpricenum {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
    margin-right: 10px;
  }

  .reserceDesc_button {
    margin-top: 21px;
  }

  /* pages/package/reserveDesc.wxss */


  .popup_top {
    display: flex;
    height: 30px;
    padding: 16px;
    border-bottom: 1px solid #d6d6d6;
    align-items: center;
    font-size: 18px;
  }

  .guanbi {
    width: 20px;
    height: 20px;
    margin-right: 130px;
  }

  .couponCell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }

  .reserceDesc_section {
    padding: 10px;
  }

  .addressList {
    width: 100%;
    box-sizing: border-box;
  }

  .addressBox {
    width: 100%;
    border-bottom: 1px solid #D2D2D2;
    padding: 5px 0;
  }

  .address_name {
    font-size: 16px;
  }

  .address_detail {
    font-size: 14px;
    color: #666666;
  }

  /* .map{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  } */
  .inspection-time {
    font-size: 16px;
    color: #BBBBBB;
    width: 100%;
  }

  .inspection-time1 {
    font-size: 16px;
    color: #000;
    width: 100%;
  }

  .service-price {
    color: #FD8C00;
    font-size: 16px;
  }

  .inspection-bannertip1 {
    font-size: 12px;
    font-weight: bold;
    margin: 15px 0;
    color: #FFFFFF;
  }

  .inspection-bannertip2 {
    font-size: 12px;
    margin-bottom: 10px;
    color: #FFFFFF;
  }

  input:disabled {
    background-color: #fff;
    opacity: 1;
  }

  /* 卡券弹出层 开始 */
  .cardlist_popup_top {
    width: 100%;
    height: 18%;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #EEEEEE;
  }

  .cardlist_popup_topcancel {
    font-size: 14px;
    color: #969799;
  }

  .cardlist_popup_topcenter {
    font-size: 16px;
  }

  .cardlist_popup_topconfirm {
    font-size: 14px;
    color: #576b95;
  }

  .cardlist_popup_list {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;

  }

  .cardlist_popup_box {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #EEEEEE;
    border-radius: 8px;
  }

  .cardlist_popup_box1 {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #FFFFFF;
    border: 1px solid #FD8C00;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cardlist_popup_box2 {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #FFFFFF;
    border: 1px solid #BBBBBB;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cardlist_popup_boxtop {
    color: #363636;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .cardlist_popup_boxbot {
    color: #BBBBBB;
    font-size: 14px;
  }

  .cardlist-pop-check {
    width: 14px;
    height: 14px;
  }

  .cardlist_popup_img {
    position: absolute;
    top: 0;
    right: 0;
    width: 69px;
    height: 23px;
  }

  /* 卡券弹出层 结束 */
</style>



// WEBPACK FOOTER //
// src/pages/offline/reservation.vue